import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { OFFERS } from "@/lib/data";

export default function OfferGrid() {
 return (
 <section
 data-testid="offers-section"
 id="offers"
 className="relative bg-ink-900 py-24 md:py-32"
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8">
 <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
 <div>
 <h2 className="font-display text-4xl md:text-5xl font-bold leading-[1.15] tracking-normal max-w-2xl">
 Choose the Experience that Fits You
 </h2>
 </div>
 <p className="text-white/60 text-sm max-w-sm">
 Every path is a real experience. Live, collaborative, and tied to
 actual placement opportunity. Not another course.
 </p>
 </div>

 <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
 {OFFERS.map((offer, i) => {
 const featured = !!offer.featured;
 const isComingSoon = !!offer.comingSoon;
 return (
 <motion.div
 key={offer.id}
 initial={{ opacity: 0, y: 30 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.55, delay: i * 0.08 }}
 data-testid={`offer-card-${offer.id}`}
 className={`group relative flex flex-col justify-between p-7 md:p-8 min-h-[440px] overflow-hidden border transition-all duration-300 ${
 featured
 ? "bg-amber text-black border-amber"
 : "bg-ink-800 border-ink-600 hover:border-amber/60 text-white"
 }`}
 >
 <div
 className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-to-b ${offer.accent} pointer-events-none`}
 />

 {isComingSoon && !featured && (
 <span
 data-testid={`offer-badge-${offer.id}`}
 className="absolute top-4 right-4 bg-amber text-black text-[10px] font-mono font-bold uppercase tracking-widest px-2.5 py-1 rounded-sm z-10"
 >
 Coming soon
 </span>
 )}

 <div className="relative pr-20">
 {offer.logo && (
 <div className="flex justify-center mb-5">
 <img
 src={offer.logo}
 alt={offer.title}
 data-testid={`offer-logo-${offer.id}`}
 className="h-32 md:h-36 w-auto object-contain"
 />
 </div>
 )}
 <p
 className={`tag-kicker ${
 featured ? "!text-black/70" : ""
 }`}
 >
 {offer.kicker}
 </p>
 <h3
 className={`font-display text-2xl md:text-3xl font-bold tracking-normal mt-4 leading-[1.2] ${
 featured ? "text-black" : ""
 }`}
 >
 {offer.title}
 </h3>
 <p
 className={`mt-3 text-sm md:text-base leading-relaxed ${
 featured ? "text-black/80" : "text-white/70"
 }`}
 >
 {offer.tagline}
 </p>
 <p
 className={`mt-4 text-sm leading-relaxed ${
 featured ? "text-black/70" : "text-white/55"
 }`}
 >
 {offer.description}
 </p>
 </div>

 <div className="relative mt-8">
 <p
 className={`font-mono text-[10px] md:text-[11px] uppercase tracking-widest mb-3 ${
 featured ? "text-black/60" : "text-white/40"
 }`}
 >
 {offer.price}
 </p>
 <Link
 to={offer.href}
 data-testid={`offer-cta-${offer.id}`}
 className={`w-full inline-flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-[11px] md:text-xs px-4 py-3 rounded-sm transition-all ${
 featured
 ? "bg-black text-amber hover:bg-ink-900"
 : "bg-white text-black hover:bg-amber"
 }`}
 >
 {offer.cta}
 <ArrowUpRight size={14} />
 </Link>
 </div>
 </motion.div>
 );
 })}
 </div>
 </div>
 </section>
 );
}
